import {
  FieldHtmlNameUtil,
  signupDecorationNewSignup,
  type CadPlanId,
  type HekateFormSubmit,
} from '@onshape/www-inertia';
import DefaultProgressiveProfile from './DefaultProgressiveProfile';

export default class UnifiedSignupProgressiveProfile extends DefaultProgressiveProfile {
  public override onClient(): void {
    super.onClient();

    const bus = useHekateEventBus();
    const { setSignupDecoration, personalizationProfileStorable } = useWwwStorage();

    bus.addEventListener('form-successfully-submitted', (event) => {
      const formDefinition = event.data.formDefinition as HekateFormSubmit;

      const planId = formDefinition.displayFields.find(
        (field) => field.htmlName === FieldHtmlNameUtil.planId
      )?.val as CadPlanId;

      const signupDecoration = signupDecorationNewSignup({
        planId,
        pathname: window.location.pathname,
        numAttempts: personalizationProfileStorable.value?.signupDecoration?.numAttempts || 0,
      });

      setSignupDecoration({
        signupDecoration,
      });
    });
  }
}
